const uk_UA = {}

uk_UA.strings = {
  addMoreFiles: 'Додати ще файли',
  addingMoreFiles: 'Додавання додаткових файлів',
  allowAccessDescription: 'Щоб зробити фото або відео, будь ласка, дозвольте доступ до камери для цього сайту',
  allowAccessTitle: 'Будь ласка, дозвольте доступ до вашої камери',
  authenticateWithTitle: 'Будь ласка, авторизуйтесь у %{pluginName}, щоб обрати файли',
  authenticateWith: 'Під\'єднатися до %{pluginName}',
  back: 'Назад',
  addMore: 'Додати ще',
  browse: 'оберіть',
  browseFiles: 'оберіть',
  cancel: 'Скасувати',
  cancelUpload: 'Скасувати завантаження',
  chooseFiles: 'Обрати файли',
  closeModal: 'Закрити вікно',
  companionError: 'Не вдалося під\'єднатися до Companion',
  complete: 'Готово',
  connectedToInternet: 'Під\'єднано до інтернету',
  copyLink: 'Копіювати посилання',
  copyLinkToClipboardFallback: 'Скопіюйте посилання',
  copyLinkToClipboardSuccess: 'Посилання скопійована в буфер обміну',
  creatingAssembly: 'Підготовка до завантаження...',
  creatingAssemblyFailed: 'Transloadit: не вдалося згенерувати Assembly',
  dashboardTitle: 'Завантажувач файлів',
  dashboardWindowTitle: 'Вікно завантажувача файлів (натисніть escape, щоб закрити)',
  dataUploadedOfTotal: '%{complete} із %{total}',
  done: 'Готово',
  dropHereOr: 'Перетягніть файли або %{browse}',
  dropHint: 'Перетягніть файли сюди',
  dropPasteBoth: 'Перетягніть файли, вставте або %{browse}',
  dropPasteFiles: 'Перетягніть файли, вставте або %{browse}',
  dropPasteFolders: 'Перетягніть файли, вставте або %{browse}',
  dropPasteImportBoth: 'Перетягніть файли, вставте, %{browse} або імпортуйте з:',
  dropPasteImportFiles: 'Перетягніть файли, вставте, %{browse} або імпортуйте з:',
  dropPasteImportFolders: 'Перетягніть файли, вставте, %{browse} або імпортуйте з:',
  editFile: 'Редагувати файл',
  editing: 'Редагується %{file}',
  emptyFolderAdded: 'Файли не додано — тека порожня',
  encoding: 'Обробка...',
  enterCorrectUrl: 'Невірна адреса: будь ласка, переконайтеся що ви використовуєте пряме посилання на файл',
  enterUrlToImport: 'Введіть адресу, щоб імпортувати файл',
  exceedsSize: 'Цей файл більше максимально дозволеного розміру в',
  failedToFetch: 'Companion не зміг завантажити файл за посиланням, будь ласка, переконайтеся, що адреса вірна',
  failedToUpload: 'Помилка завантаження %{file}',
  fileSource: 'Джерело файлу: %{name}',
  filesUploadedOfTotal: {
    '0': '%{complete} із %{smart_count} файл завантажено',
    '1': '%{complete} із %{smart_count} файлів завантажено',
    '2': '%{complete} із %{smart_count} файлів завантажено'
  },
  filter: 'Фільтр',
  finishEditingFile: 'Завершити редагування файлу',
  folderAdded: {
    '0': 'Додано %{smart_count} файл із %{folder}',
    '1': 'Додано %{smart_count} файли із %{folder}',
    '2': 'Додано %{smart_count} файлів із %{folder}'
  },
  import: 'Імпортувати',
  importFrom: 'Імпортувати з %{name}',
  loading: 'Завантаження...',
  logOut: 'Вийти',
  myDevice: 'Мій пристрій',
  noFilesFound: 'Тут відсутні файли або теки',
  noInternetConnection: 'Відсутнє підключення до мережі Інтернет',
  pause: 'Поставити на паузу',
  pauseUpload: 'Поставити завантаження на паузу',
  paused: 'На паузі',
  processingXFiles: {
    '0': 'Обробляється %{smart_count} файл',
    '1': 'Обробляється %{smart_count} файли',
    '2': 'Обробляється %{smart_count} файлів'
  },
  poweredBy: 'Працює на',
  removeFile: 'Знищити файл',
  resetFilter: 'Скинути фільтр',
  resume: 'Продовжити',
  resumeUpload: 'Продовжити завантаження',
  retry: 'Спробувати знову',
  retryUpload: 'Повторити спробу завантаження',
  saveChanges: 'Зберегти',
  selectX: {
    '0': 'Обрати %{smart_count}',
    '1': 'Обрати %{smart_count}',
    '2': 'Обрати %{smart_count}'
  },
  smile: 'Посміхніться!',
  startRecording: 'Почати запис відео',
  stopRecording: 'Закінчити запис відео',
  takePicture: 'Зробити фотографію',
  timedOut: 'Завантаження зупинилося на %{seconds} сек., скасування',
  upload: 'Завантажити',
  uploadComplete: 'Завантаження завершено',
  uploadFailed: 'Завантаження не вдале',
  uploadPaused: 'Завантаження на паузі',
  uploadXFiles: {
    '0': 'Завантажити %{smart_count} файл',
    '1': 'Завантажити %{smart_count} файли',
    '2': 'Завантажити %{smart_count} файлів'
  },
  uploadXNewFiles: {
    '0': 'Завантажити +%{smart_count} файл',
    '1': 'Завантажити +%{smart_count} файли',
    '2': 'ЗЗавантажити +%{smart_count} файлів'
  },
  uploading: 'Завантаження',
  uploadingXFiles: {
    '0': 'Завантажується %{smart_count} файл',
    '1': 'Завантажується %{smart_count} файли',
    '2': 'Завантажується %{smart_count} файлів'
  },
  xFilesSelected: {
    '0': '%{smart_count} файл обрано',
    '1': '%{smart_count} файли обрано',
    '2': '%{smart_count} файлів обрано'
  },
  xMoreFilesAdded: {
    '0': '%{smart_count} додатковий файл додано',
    '1': '%{smart_count} додаткові файли додано',
    '2': '%{smart_count} додаткових файлів додано'
  },
  xTimeLeft: 'залишилося %{time}',
  youCanOnlyUploadFileTypes: 'Ви можете завантажити тільки: %{types}',
  youCanOnlyUploadX: {
    '0': 'Ви можете завантажити тільки %{smart_count} файл',
    '1': 'Ви можете завантажити тільки %{smart_count} файли',
    '2': 'Ви можете завантажити тільки %{smart_count} файлів'
  },
  youHaveToAtLeastSelectX: {
    '0': 'Ви повинні обрати хоча б %{smart_count} файл',
    '1': 'Ви повинні обрати хоча б %{smart_count} файли',
    '2': 'Ви повинні обрати хоча б %{smart_count} файлів'
  },
  selectAllFilesFromFolderNamed: 'Обрати всі файли з теки %{name}',
  unselectAllFilesFromFolderNamed: 'Скасувати вибір усіх файлів з теки %{name}',
  selectFileNamed: 'Обрати файл %{name}',
  unselectFileNamed: 'Скасувати вибір файлу %{name}',
  openFolderNamed: 'Відкрити теку %{name}'
}

uk_UA.pluralize = function (n) {
  if (n % 10 === 1 && n % 100 !== 11) {
    return 0
  }

  if (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20)) {
    return 1
  }

  return 2
}

if (typeof window !== 'undefined' && typeof window.Uppy !== 'undefined') {
  window.Uppy.locales.uk_UA = uk_UA
}

module.exports = uk_UA
